import { AbstractAccessorService } from "@core/data-access";
import type { IDataAccessor } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import { ILocationType } from "@modules/user/model/domain/address/location-type";
import { ILocationTypeConfigService } from "./location-type";


export class LocationTypeConfigService extends AbstractAccessorService<ILocationType> implements ILocationTypeConfigService {
    public readonly $name: string = "LocationTypeConfigService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<ILocationType>) {
        super();
    }

    /**
     * @description 获取地址locationType配置
     * */
    public getLocationType(): angular.IPromise<IResponse<Array<ILocationType>>> {
        return this.$accessor<Array<ILocationType>, {}, string>(this.$name, "getLocationType");
    }
}